import gql from "graphql-tag";

const createEmployeeAnnualLeaveDay = gql`
  mutation(
    $default: Float
    $remain: Float
    $employeeId: ID!
    $original: Float
  ) {
    createEmployeeAnnualLeaveDay(
      data: {
        default: $default
        remain: $remain
        employeeId: $employeeId
        original: $original
      }
    ) {
      id
      default
      remain
      original
      employeeId
    }
  }
`;

const updateEmployeeAnnualLeaveDay = gql`
  mutation($id: ID!, $default: Float, $remain: Float, $original: Float) {
    updateEmployeeAnnualLeaveDay(
      id: $id
      data: { default: $default, remain: $remain, original: $original }
    ) {
      id
      default
      remain
      original
      employeeId
    }
  }
`;

export default { createEmployeeAnnualLeaveDay, updateEmployeeAnnualLeaveDay };
